import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { CookieService } from '@laurentgoudet/ngx-cookie';
import * as Rx from 'rxjs';
import { catchError, filter, finalize, map, mapTo, skip, switchMap, take, tap, withLatestFrom, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./auth.config";
import * as i2 from "@laurentgoudet/ngx-cookie";
import * as i3 from "@angular/common/http";
var Auth = /** @class */ (function () {
    function Auth(authConfig, platformId, cookies, http) {
        var _this = this;
        this.authConfig = authConfig;
        this.cookies = cookies;
        this.http = http;
        // TODO: we should provide those to CookieModule.forRoot but it's tricky
        // because of AoT, best is probably to extend `@laurentgoudet/ngx-cookie`
        this.authCookiesExpires = new Date(new Date().setMonth(new Date().getMonth() + 1));
        this._authStateSubject$ = new Rx.ReplaySubject(1);
        // read session from cookie if any
        var userId;
        var token;
        if (isPlatformBrowser(platformId)) {
            userId = this.cookies.get(this.authConfig.userIdCookie);
            token = this.cookies.get(this.authConfig.authHashCookie);
        }
        if (userId && token) {
            this._authStateSubject$.next({ userId: userId, token: token });
        }
        else {
            this._authStateSubject$.next(undefined);
        }
        // keep auth cookies in sync with session
        this._authStateSubject$.pipe(skip(1)).subscribe(function (s) {
            if (s) {
                _this.cookies.put(_this.authConfig.userIdCookie, s.userId, {
                    expires: _this.authCookiesExpires,
                });
                _this.cookies.put(_this.authConfig.authHashCookie, s.token, {
                    expires: _this.authCookiesExpires,
                });
            }
            else {
                _this.cookies.remove(_this.authConfig.userIdCookie);
                _this.cookies.remove(_this.authConfig.authHashCookie);
            }
        });
    }
    Object.defineProperty(Auth.prototype, "authState$", {
        get: function () {
            return this._authStateSubject$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Auth.prototype.getUserId = function () {
        return this.authState$.pipe(filter(isDefined), map(function (auth) { return auth.userId; }));
    };
    Auth.prototype.isLoggedIn = function () {
        return this.authState$.pipe(map(function (state) { return !!state; }));
    };
    Auth.prototype.generateCSRFToken = function (length, charset) {
        var result = '';
        for (var i = length; i > 0; --i) {
            result += charset[Math.floor(Math.random() * charset.length)];
        }
        return result;
    };
    Auth.prototype.getCSRFToken = function () {
        var token = this.cookies.get(this.authConfig.csrfCookie);
        if (!token) {
            token = this.generateCSRFToken(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
            this.cookies.put(this.authConfig.csrfCookie, token, {
                expires: this.authCookiesExpires,
            });
        }
        return token;
    };
    Auth.prototype.getAuthorizationHeader = function () {
        return this.authState$.pipe(map(function (auth) {
            if (!auth) {
                return new HttpHeaders();
            }
            return new HttpHeaders().set('freelancer-auth-v2', auth.userId + ";" + auth.token);
        }));
    };
    Auth.prototype.setSession = function (userId, token) {
        this._authStateSubject$.next({ userId: userId, token: token });
    };
    Auth.prototype.deleteSession = function () {
        this._authStateSubject$.next(undefined);
    };
    // FIXME T38832: This needs 2 AJAX calls because GAF.
    Auth.prototype.switchUser = function (newUserId) {
        var _this = this;
        return this.authState$
            .pipe(take(1), switchMap(function (auth) {
            if (!auth) {
                throw new Error('no user to switch account from');
            }
            var body = new FormData();
            body.append('user', auth.userId);
            body.append('other_user', newUserId);
            body.append('token', auth.token);
            return _this.http
                .post(_this.authConfig.baseUrl + "/switch_account/", body)
                .pipe(map(function (response) { return response.result.token; }));
        }), withLatestFrom(this.getAuthorizationHeader()), switchMap(function (_a) {
            var newUserToken = _a[0], authHeader = _a[1];
            var body = new FormData();
            body.append('user', newUserId);
            body.append('token', newUserToken);
            return _this.http
                .post(_this.authConfig.switchAccountHackyEndpoint, body, {
                headers: authHeader,
            })
                .pipe(map(function (response) { return ({ response: response, newUserToken: newUserToken }); }));
        }), tap(function (_a) {
            var newUserToken = _a.newUserToken;
            return _this._authStateSubject$.next({
                userId: newUserId,
                token: newUserToken,
            });
        }), map(function (_a) {
            var response = _a.response;
            return response.result.gotoUrl;
        }))
            .toPromise();
    };
    Auth.prototype.logout = function () {
        var _this = this;
        return this.authState$.pipe(take(1), switchMap(function (auth) {
            if (!auth) {
                throw new Error('no user to logout');
            }
            var body = new FormData();
            body.append('user', auth.userId);
            body.append('token', auth.token);
            return _this.http.post(_this.authConfig.baseUrl + "/logout/", body);
        }), mapTo(undefined), finalize(function () { return _this._authStateSubject$.next(undefined); }), catchError(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                throw err.error;
            }
            // The backend returned an unsuccessful response code.
            console.error(err.message, err.error);
            return Rx.of(undefined);
        }));
    };
    Auth.ngInjectableDef = i0.defineInjectable({ factory: function Auth_Factory() { return new Auth(i0.inject(i1.AUTH_CONFIG), i0.inject(i0.PLATFORM_ID), i0.inject(i2.CookieService), i0.inject(i3.HttpClient)); }, token: Auth, providedIn: "root" });
    return Auth;
}());
export { Auth };
function isDefined(x) {
    return x !== undefined && x !== null;
}
